import { trpc } from '@/services/trpc';
import { useBoundStore } from '@/store/store';

export function useCurrentOrganization() {
  const jwt = useBoundStore(state => state.jwt);
  const currentOrganizationId = useBoundStore(
    state => state.currentOrganizationId,
  );
  const transitioning = useBoundStore(state => state.organizationTransitioning);
  const query = trpc.organizations.getCurrent.useQuery(undefined, {
    enabled: !!jwt && !!currentOrganizationId && !transitioning,
  });
  const organization =
    !transitioning && query.data?.id === currentOrganizationId
      ? query.data
      : undefined;

  return {
    ...query,
    data: organization,
    organization,
    isContextMismatch:
      !transitioning && !!query.data && query.data.id !== currentOrganizationId,
  };
}
